export default __webpack_public_path__ + "static/media/warehouse-1.81eb931c.png";